(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        $('#savemodal').click(function(){

            var target = $(this).attr('data-targetform');
            var $target = $(target);

            if (!window.checkForm(target)) return;

            var modal = $(this).attr('data-targetmodal');

            var l = Ladda.create(this);
            l.start();



            $.post($target.attr('action'), $target.serialize())
                .done(function(data){
                    if (data.status=='ok') {
                        window.clear_form_elements(target);
                        $(modal).modal('hide');
                        $(document).trigger('savemodal:clear');
                        //  $(document).trigger(' selectizeajax:clear');

                        if (window.modalfire != undefined) {
                            $(document).trigger(window.modalfire, [data]);
                            window.modalfire = undefined;
                        }else{
                            $(document).trigger('selectizeajax:addcontact', [{id: data.id, name: data.name}]);
                            $(document).trigger('contactmodal:addcontact', [data]);
                        }
                    }else{
                        if (data.error_message!=undefined)
                            window.inMessageError(data.error_message);
                    }
                })
                .always(function() { l.stop(); });



        });

        $('#cancelmodal').click(function(){
            var target =  $('#savemodal').attr('data-targetform');
            window.clear_form_elements(target);
            $(document).trigger('savemodal:clear');
            window.modalfire = undefined;
        })

        window.cancelModal = function(){
            $('#cancelmodal').trigger('click');
        }

    });





})(document, window, jQuery);